import { render, staticRenderFns } from "./Hots.vue?vue&type=template&id=315fcef4&scoped=true"
import script from "./Hots.vue?vue&type=script&lang=js"
export * from "./Hots.vue?vue&type=script&lang=js"
import style0 from "./Hots.vue?vue&type=style&index=0&id=315fcef4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315fcef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315fcef4')) {
      api.createRecord('315fcef4', component.options)
    } else {
      api.reload('315fcef4', component.options)
    }
    module.hot.accept("./Hots.vue?vue&type=template&id=315fcef4&scoped=true", function () {
      api.rerender('315fcef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/sidebar/Hots.vue"
export default component.exports